module.exports = __webpack_public_path__ + "static/media/how-it-works-privacy-2x.1e896c10.png";